import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './sucursal.css'
import { getWharehouseInfo } from 'redux/actions/clientsActions'
import { CustomDropdownSelector } from 'Views/Clientes/CrearCliente/components/CustomDropdownSelector.jsx'

const Sucursales = ({ insideForm, selectedAddress, onSucursalSelected }) => {
  const [sucursales, setSucursales] = useState([])
  const [sucursalSelected, setSucursalSelected] = useState(
    selectedAddress || null
  )
  const companyId = useSelector(state => state.company.CompanyId)
  const WarehouseId = useSelector(state => state.company.WarehouseId)
  const dispatch = useDispatch()

  const manualChangeRef = useRef(false)
  const hasAutoSelectedRef = useRef(false)

  const handleSucursalSelected = sucursal => {
    manualChangeRef.current = true
    setSucursalSelected(sucursal)
    onSucursalSelected(sucursal)
  }

  const fetchWarehouses = async () => {
    const payload = {
      companyId,
      tenantId: 2,
      SearchText: null,
      PageNumber: 1,
      PageSize: 100,
    }
    const warehouseInfo = await dispatch(getWharehouseInfo(payload))
    const warehouses = warehouseInfo
      .map(branch => {
        const composedWarehouse = {
          ...branch.Warehouses[0],
          WarehouseAddress: branch.Address_AddressDetail,
        }
        return composedWarehouse
      })
      .filter(warehouse => {
        return warehouse.Description !== undefined
      })
    setSucursales(prevState => [...prevState, ...warehouses])
  }

  useEffect(() => {
    fetchWarehouses()
  }, [companyId])

  useEffect(() => {
    if (selectedAddress && !manualChangeRef.current) {
      setSucursalSelected(selectedAddress)
    } else if (!selectedAddress) {
      manualChangeRef.current = false
    }
  }, [selectedAddress])

  useEffect(() => {
    // Si ya se ha auto-seleccionado una vez, no volver a hacerlo
    if (hasAutoSelectedRef.current) {
      return
    }

    if (sucursales.length === 0) {
      return
    }

    let autoSelectWarehouse = null

    // Si hay selectedAddress, buscar la sucursal que coincida con ella
    if (selectedAddress && selectedAddress.WarehouseId) {
      autoSelectWarehouse = sucursales.find(
        sucursal => sucursal.WarehouseId === selectedAddress.WarehouseId
      )
    }
    // Si no hay selectedAddress, buscar por WarehouseId
    else if (!selectedAddress && WarehouseId) {
      autoSelectWarehouse = sucursales.find(
        sucursal => sucursal.WarehouseId === WarehouseId
      )
    }

    // Si encontró una sucursal para auto-seleccionar
    if (autoSelectWarehouse && !manualChangeRef.current) {
      handleSucursalSelected(autoSelectWarehouse)
      hasAutoSelectedRef.current = true
    }
  }, [sucursales, selectedAddress, WarehouseId])

  return (
    <div className="content-sucursal" style={{ padding: insideForm && '0' }}>
      <CustomDropdownSelector
        label="Seleccione una sucursal"
        labelClassName="field-label"
        value={sucursalSelected}
        options={sucursales}
        onSelect={item => handleSucursalSelected(item)}
        getOptionLabel={item => item.Description}
        getOptionValue={item => item.WarehouseId}
        error=""
        name="sucursales-select"
      />
    </div>
  )
}

export default Sucursales
